import _ from 'lodash';
import { tableData, cols } from '@/testdata/TwTableData_processes';

function addPropExcludeKeys(columns) {
  const excluded = ['subordinateInfo'];
  return columns
    .filter((col) => !excluded.includes(col.key))
    .map((col) => ({
      ...col,
      prop: col.key,
      showOverflowTooltip: true,
    }));
}

const patterns = {
  patternA: {
    cols: [
      {
        prop: 'processProgressStatusCd',
        label: '',
        width: 100,
        sortable: true,
        align: 'center',
      },
      { prop: 'id', label: 'ID', width: 80, sortable: true },
      { prop: 'name', label: '名前', slot: 'nameSlot' },
      { prop: 'email', label: 'Email' },
    ],
    tableData: [
      {
        id: '001',
        name: '田中 太郎',
        email: 'tanaka@example.com',
        processProgressStatusCd: 0,
      },
      {
        id: '002',
        name: '山田 花子',
        email: 'yamada@example.com',
        processProgressStatusCd: 1,
      },
      {
        id: '003',
        name: '田中 三郎',
        email: 'tanaka@example.com',
        processProgressStatusCd: 4,
      },
    ],
  },
  patternB: {
    cols: [
      { prop: 'name', label: '氏名' },
      {
        prop: 'email',
        label: 'メール',
        editable: true,
        rules: [
          { required: true, message: 'メールは必須です', trigger: 'blur' },
          { min: 2, message: '2文字以上で入力してください', trigger: 'blur' },
        ],
      },
      { prop: 'phone', label: '電話番号', editable: true, type: 'input' },
      {
        prop: 'sex',
        label: '性別',
        editable: true,
        type: 'select',
        options: [
          { label: '男', value: 1 },
          { label: '女', value: 2 },
        ],
      },
    ],
    tableData: [
      {
        id: '004',
        name: '佐藤 一郎',
        email: 'sato@example.com',
        phone: '09012341234',
        sex: 1,
      },
      {
        id: '004',
        name: '佐藤 次郎',
        email: 'sato@example.com',
        phone: '09012341234',
        sex: 2,
      },
    ],
  },
  patternC: {
    cols: addPropExcludeKeys(cols),
    tableData,
  },
  patternD: {
    cols: [
      { prop: 'name', label: '氏名' },
      {
        prop: 'email',
        label: 'メール',
        editable: true,
      },
      {
        prop: 'phone',
        label: '電話番号',
        editable: true,
        type: 'input',
      },
      {
        prop: 'sex',
        label: '性別',
        editable: true,
        type: 'select',
        options: [
          { label: '男', value: 1 },
          { label: '女', value: 2 },
        ],
      },
    ],
    tableData: [
      {
        id: '001',
        name: '田中 一郎',
        email: 'sato@example.com',
        phone: '09012341234',
        sex: 1,
      },
      {
        id: '002',
        name: '田中 次郎',
        email: 'sato@example.com',
        phone: '09012341234',
        sex: 2,
      },
    ],
  },
};
// 指定されたパターン文字列でデータを返す関数
export function getTestTableData(patternName = 'patternA') {
  console.log('patter: ', patterns['patternC']);
  return patterns[patternName] || patterns['patternA'];
}
